/* eslint-disable prefer-const */
// copy from @remix-run/react
function getData(dataSelect) {
  try {
    const inlineJsonElement = document.querySelector(`script[type="application/json"][data-ttark="${dataSelect}"]`);
    const content = decodeURIComponent(inlineJsonElement.textContent);
    const data = JSON.parse(content);
    return data;
  } catch (err) {
    console.error(`Couldn't read JSON data from ${dataSelect}`, err);
    return {};
  }
}
async function setRemixRouteModules(remixContext) {
  const { matches, manifest } = remixContext;
  const remixRouteModules = {};

  if (manifest.hmr?.runtime) {
    await import(manifest.hmr.runtime);
  }
  await import(manifest.url);

  await Promise.all(
    matches.map(async (match) => {
      try {
        const route = await import(manifest.routes[match.route.id].module);
        remixRouteModules[match.route.id] = route;
        return route;
      } catch (err) {
        console.error('load remix module fail');
        console.error(err);
      }
    }),
  );

  window.__remixRouteModules = remixRouteModules;
  try {
    await import(manifest.entry.module);
  } catch (err) {
    console.error('load remix moudle fail');
    console.error(err);
  }
}
const isBrowser =
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined';

if (isBrowser) {
  // work to replace Remix Scripts
  // see detail at https://bytedance.larkoffice.com/wiki/CoaWwrpSniUU7WkczlKcM2s6nrb
  const remixContext = getData('__remixContext');

  // assign the serverHandoff value to __remixContext
  window.__remixContext = remixContext;

  // declare __remixContext functions
  window.__remixContext.p = function (v, e, p, x) {
    if (typeof e !== 'undefined') {
      if (window.__remixContext.NODE_ENV === 'development') {
        x = new Error(e.message);
        x.stack = e.stack;
      } else {
        x = new Error('Unexpected Server Error');
        x.stack = undefined;
      }

      p = Promise.reject(x);
    } else {
      p = Promise.resolve(v);
    }
    return p;
  };
  window.__remixContext.n = function (i, k) {
    window.__remixContext.t = window.__remixContext.t || {};
    window.__remixContext.t[i] = window.__remixContext.t[i] || {};
    let p = new Promise((r, e) => {
      window.__remixContext.t[i][k] = {
        r: (v) => {
          r(v);
        },
        e: (v) => {
          e(v);
        },
      };
    });
    if (typeof window.__remixContext.abortDelay === 'number') {
      setTimeout(() => {
        if (typeof p._error !== 'undefined' || typeof p._data !== 'undefined') {
          return;
        }
        window.__remixContext.t[i][k].e(new Error('Server timeout.'));
      }, window.__remixContext.abortDelay);
    }
    return p;
  };
  window.__remixContext.r = function (i, k, v, e, p, x) {
    p = window.__remixContext.t[i][k];
    if (typeof e !== 'undefined') {
      if (window.__remixContext.NODE_ENV === 'development') {
        x = new Error(e.message);
        x.stack = e.stack;
      } else {
        x = new Error('Unexpected Server Error');
        x.stack = undefined;
      }
      p.e(x);
    } else {
      p.r(v);
    }
  };
  // work to replace Object.assign(__remixContext.state.loaderData[xxx], xxx)
  let loaderStateStore = window.__remixContext.loaderStateStore;
  if (loaderStateStore) {
    Object.entries(loaderStateStore).forEach(([key, value]) => {
      // eslint-disable-next-line no-eval
      eval(`Object.assign(__remixContext.state.loaderData[${key}], {${value}})`);
    });
  }

  if (window.__remixContext.isStatic) {
    setRemixRouteModules(window.__remixContext);
  }
}
